export default "__VITE_ASSET__5h9GeedC__"